import mixins from 'synergycms_core/src/less/mixins';

export default {
  defaultStyle: {
    font: data => '300 13px ' + data.fontFamily1,
    color: data => data.fifthColor,
    cursor: 'pointer',
    '& span': {
      cursor: 'pointer'
    }
  },
  filterOptions: {},
  checkSelected: {},
  extrasChecked:{},
  checkboxLabel: {
    cursor: "pointer",
    position: 'relative',
    display: 'block',
    paddingLeft: '29px',
    '&:before': {
      content: "''",
      position: 'absolute',
      left: '0',
      top: '0',
      height: '18px',
      width: '18px',
      border: '1px solid #ddd',
    },
    '&:lang(ar)': {
      '&:before': {
        left: 'auto',
        right: 0
      },
    },
    '& $filterOptions': {
      position: 'fixed',
      top: '0',
      left: '-999px',
      width: '0',
      height: '0',
      ...mixins.opacity(0),
      '&:lang(ar)': {
        left: 'auto',
        right: '-999px'
      }
    },
    '& $checkSelected': {
      '&:before': {
        content: "'\\e046'",
        font: data => '8px/21px ' + data.fontFamily3,
        position: 'absolute',
        left: '0',
        top: '0',
        width: '20px',
        textAlign: 'center',
        color: 'transparent',
        ...mixins.transition()
      },
      '&:lang(ar)': {
        '&:before': {
          left: 'auto',
          right: 0
        },
      },
    },
    '& $extrasChecked':{
      composes:'$checkSelected',
      '&:before': {
        content: "'\\e046'",
        font: data => '8px/22px ' + data.fontFamily3,
        position: 'absolute',
        left: '0',
        top: '0',
        width: '22px',
        textAlign: 'center',
        color: 'transparent',
        ...mixins.transition()
      }
    },
    '& input:checked ~ $checkSelected:before': {
      color: data => data.mainColor,
      fontSize: '11px'
    },
    '& input:checked ~ $extrasChecked:before': {
      color: data => data.mainColor,
      fontSize: '11px'
    },
    '&:lang(ar)': {
      textAlign: 'left',
      paddingLeft:0,
      paddingRight:'29px',
      '&:before': {
        left: 'auto',
        right: 0
      },
    },
  },
  '& mark': {
    fontSize: '13px',
    fontWeight: '300',
    color: data => data.fourthColor,
    marginLeft: '5px',
    '&:lang(ar)': {
      marginLeft: 0,
      marginRight: '5px'
    }
  }
};
